document.addEventListener('DOMContentLoaded', function () {
    var article_title = "{{ article.title }}";
    var articleID = "{{ article.id }}";
    fetch("http://127.0.0.1:8000/shopify/ww-articles/viewCount", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            blogTitle: article_title,
            articleID: articleID,

        }),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        })
        .then((data) => {
            console.log("View count updated successfully:", data.count);
        })
        .catch((error) => {
            console.error("Error updating view count:", error);
        });;
    const span = document.querySelector('.view-count_number');
    const storageKey = 'view-count';

    if (span) {
        let count = sessionStorage.getItem(storageKey);

        if (count !== null) {
            count = parseInt(count, 10) + 1;
        } else {
            count = parseInt(span.getAttribute('data-count'), 10) + 1;
        }

        sessionStorage.setItem(storageKey, count);
        span.setAttribute('data-count', count);
        span.textContent = `${count} Views`;
    }
});
$('.scrollTrigarBlock a.blockHeader').on('click', function () {
    $(this).attr('href', 'javascript:void(0)');
    $(this).toggleClass('scrollTriggerToggle');

    let content = $(this).siblings('.collapse')[0];
    let collapsedHeight = '0px';

    if ($(content).hasClass('show')) {
        content.style.maxHeight = content.scrollHeight + 'px';

        setTimeout(() => {
            content.style.maxHeight = collapsedHeight;
        }, 10);

        setTimeout(() => {
            $(content).removeClass('show');
        }, 600);
    } else {
        $(content).addClass('show');
        content.style.maxHeight = content.scrollHeight + 'px';
    }
});

const accordionContent = document.querySelectorAll('.accordion-content');
const accordionToggle = document.querySelectorAll('.accordion-toggle');

$('.accordion-content').addClass('open');
$('.accordion-toggle').addClass('active');

accordionToggle.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
        toggle.classList.toggle('active');
        const content = toggle.nextElementSibling;
        if (content) {
            content.classList.toggle('open');
        }
    });
});

// Recomended article listings handled from the recomended products
document.addEventListener('DOMContentLoaded', function () {
    const recomendedList = document.querySelector('.recomended-articles-list');
    const recomendedListItems = recomendedList?.querySelectorAll('.recomended-articles-list-item');

    if (recomendedListItems) {
        if (recomendedListItems.length > 0) {
            // Hide all list items
            recomendedListItems.forEach((item) => (item.style.display = 'none'));

            // Select a random one and show it
            const randomIndex = Math.floor(Math.random() * recomendedListItems.length);
            recomendedListItems[randomIndex].style.display = 'block';
        }
    }
});

// Highlight functionality
function highlightText(element, pattern) {
    function innerHighlight(node, pat) {
        if (node.nodeType === 3) { // Text node
            const text = node.data;
            const upperText = text.toUpperCase();
            const upperPat = pat.toUpperCase();
            let pos = upperText.indexOf(upperPat);

            while (pos >= 0) {
                // Split the text node at the match position
                const matchNode = node.splitText(pos);
                const afterNode = matchNode.splitText(pat.length);

                // Create highlight span
                const highlightSpan = document.createElement('span');
                highlightSpan.className = 'highlight';
                highlightSpan.textContent = matchNode.data;

                // Replace the matched text with highlight span
                matchNode.parentNode.replaceChild(highlightSpan, matchNode);

                // Continue searching in the remaining text
                node = afterNode;
                const newText = node.data;
                const newUpperText = newText.toUpperCase();
                pos = newUpperText.indexOf(upperPat);
            }
        }
        else if (node.nodeType === 1 && node.childNodes &&
            !/(script|style|textarea)/i.test(node.tagName)) {
            // Process child nodes (reverse order to avoid index issues)
            const children = Array.from(node.childNodes);
            for (let i = 0; i < children.length; i++) {
                innerHighlight(children[i], pat);
            }
        }
    }

    const targetElements = typeof element === 'string'
        ? document.querySelectorAll(element)
        : [element];

    targetElements.forEach(el => {
        innerHighlight(el, pattern);
    });
}

// Remove highlight functionality (your original is good)
function removeHighlight(element) {
    function newNormalize(node) {
        const children = Array.from(node.childNodes);

        for (let i = 0; i < children.length; i++) {
            const child = children[i];

            if (child.nodeType === 1) {
                newNormalize(child);
                continue;
            }

            if (child.nodeType !== 3) continue;

            // Merge adjacent text nodes
            if (i + 1 < children.length && children[i + 1].nodeType === 3) {
                const next = children[i + 1];
                const combinedText = child.nodeValue + next.nodeValue;
                const newTextNode = document.createTextNode(combinedText);

                node.insertBefore(newTextNode, child);
                node.removeChild(child);
                node.removeChild(next);

                // Restart with updated children
                return newNormalize(node);
            }
        }
    }

    const targetElements = typeof element === 'string'
        ? document.querySelectorAll(element)
        : [element];

    targetElements.forEach(el => {
        const highlights = el.querySelectorAll('span.highlight');
        highlights.forEach(highlight => {
            const parent = highlight.parentNode;
            if (parent && highlight.firstChild) {
                // Replace highlight span with its text content
                const textNode = document.createTextNode(highlight.textContent);
                parent.replaceChild(textNode, highlight);
                newNormalize(parent);
            }
        });
    });
}

// Initialize
document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('search-input');

    if (searchInput) {
        searchInput.addEventListener('input', function () {
            const searchTerm = this.value;

            const contentElements = '.left-side-wrapper.article-template__content';

            // Remove existing highlights
            removeHighlight(contentElements);

            if (searchTerm.length >= 3) {
                highlightText(contentElements, searchTerm);

                // Optional: Scroll to first highlight
                const firstHighlight = document.querySelector('.highlight');
                if (firstHighlight) {
                    firstHighlight.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }
        });
    }
});

// FAQ's Accordion
document.querySelectorAll('.seo-product_article .returnAccord-block_triggr').forEach(link => {
    link.addEventListener('click', function (event) {
        event.preventDefault(); // prevents page jump
        this.classList.toggle('collapsed');

        const content = this.nextElementSibling; // equivalent to .siblings('.collapse')[0]
        const collapsedHeight = '0px';

        if (content.classList.contains('show')) {
            // closing animation
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(() => {
                content.style.maxHeight = collapsedHeight;
            }, 10);
            setTimeout(() => {
                content.classList.remove('show');
            }, 400);
        } else {
            // opening animation
            content.classList.add('show');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    });
});

// Method 2: Using getBoundingClientRect with offset for fixed headers
document.addEventListener('DOMContentLoaded', function () {
    const anchorElements = document.querySelectorAll('.scrollTrigarBlock .scrollMenu a');
    anchorElements?.forEach((each) => {
        each.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = each.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                smoothScrollToElement(targetElement, 160);
            }
        });
    })

    function smoothScrollToElement(element, offset = 0) {
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const scrollPosition = absoluteElementTop - offset;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
    }
});
